module.exports = __webpack_public_path__ + "img/test.4c03dd8a.svg";